var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'twinkle-effect',
    _vm.position === 'bottom' ? 'twinkle-effect--bottom' : '' ]},[_c('img',{staticClass:"twinkle-effect__image",attrs:{"src":_vm.currentImage,"alt":"Twinkle decoration"}})])}
var staticRenderFns = []

export { render, staticRenderFns }